export class ActivationHelper {
  public static LAST_GUID = 'DeviceGuid';
  public static LAST_USER_AGENT = 'DeviceHeader'

  public static getSavedGuid(): string | null {
    const savedGuid = localStorage.getItem(this.LAST_GUID);
    if(savedGuid !== null) {
      return String(savedGuid)
    }
    return null;
  }

  public static saveLastGuid(guid: string): void {
    const savedGuid = localStorage.getItem(this.LAST_GUID);
    if (savedGuid == null) {
      localStorage.setItem(this.LAST_GUID, String(guid));
    }

  }

  public static getSaveUserAgent(): string | null {
    const savedUserAgent = localStorage.getItem(this.LAST_USER_AGENT);
    if(savedUserAgent !== null) {
      return String(savedUserAgent)
    }
    return null;
  }

  public static saveUserAgent(boxHeader:string): void{
    const savedInfo = localStorage.getItem(this.LAST_USER_AGENT);
    if(savedInfo == null) {
      localStorage.setItem(this.LAST_USER_AGENT, String(boxHeader));
    }
  }
}
